import styled from '@emotion/styled';
import { Card, CardContent } from '@material-ui/core';
import { createElement, FC } from 'react';

import AspectRatioFixed from '../primitive/AspectRatioFixed';
import DummyContent from '../primitive/DummyContent';
import DummyRectangle from '../primitive/DummyRectangle';

interface Props {
  className?: string;
}

const DummyLatestInsightItem: FC<Props> = ({ className }) => (
  <Root className={className}>
    <DummyThumbnail aspectRatio={[3, 2]}>
      <DummyRectangle />
    </DummyThumbnail>
    <CardContent>
      <DummyContent size="subtitle1" length={100} />
      <DummyContent size="subtitle1" length={100} />

      <DummyContent size="body1" length={100} />
      <DummyContent size="body1" length={100} />
      <DummyContent size="body1" length={90} />
    </CardContent>
  </Root>
);

const DummyThumbnail = styled(AspectRatioFixed)();

const Root = styled(Card)({
  height: '100%',
});

export default DummyLatestInsightItem;
